// extracted by mini-css-extract-plugin
export default {"container":"layout_container__T+lEo","pageContainer":"layout_pageContainer__KWTK7","table":"layout_table__AtucK","outlet":"layout_outlet__IQZ-T"};